import styled from "@emotion/styled";
import { Typography, Form, Switch } from "antd";
import UploadImages from "../../UploadImages";
import { FC } from "react";
import { allowFileExtensionsImage } from "config";

interface ProductImageCardProps {
  is_active: boolean;
  setCheckIsActive: (checkIsActive: boolean) => void;
  is_guid: boolean;
  setIsGuid: (is_guid: boolean) => void;
}

const ProductImageCard: FC<ProductImageCardProps> = ({ is_active, setCheckIsActive, is_guid, setIsGuid }) => {
  return (
    <>
      <TextWrapper>
        <Typography.Text>รูปภาพสินค้า</Typography.Text>
        <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
          <Form.Item
            label="ออก GUID"
            name="is_guid"
            valuePropName="checked"
            // rules={[{ required: false, message: "กรุณากรอกชื่อสินค้า" }]}
            className="switch-form-item"
          >
            <Switch
              onChange={(value) => {
                setIsGuid(value);
              }}
              checked={is_guid}
            />
          </Form.Item>
          <Form.Item
            label="เปิดการขาย"
            name="is_active"
            valuePropName="checked"
            rules={[{ required: false, message: "กรุณากรอกชื่อสินค้า" }]}
            className="switch-form-item"
          >
            <Switch
              onChange={(value) => {
                setCheckIsActive(value);
              }}
            />
          </Form.Item>
        </div>
      </TextWrapper>
      <UploadWrapper>
        <Form.Item
          name="main_images"
          rules={[
            {
              required: is_active,
              message: "กรุณาเพิ่มรูปภาพสินค้า",
            },
          ]}
        >
          <UploadImages allowFileExtensions={allowFileExtensionsImage} maximumUploadItems={10} />
        </Form.Item>
      </UploadWrapper>
    </>
  );
};

export default ProductImageCard;

// scroll x direction
const UploadWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 0px 0px 8px 8px;
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 10px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
